module.exports = __webpack_public_path__ + "static/media/foto_4.a493c4dd.png";